import { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import autoBind from 'react-autobind';
import classNames from 'classnames/bind';
import axios from 'axios';
import isEqual from 'lodash-es/isEqual';
import { Link, withRouter } from 'react-router-dom';
import { isMobileOnly } from 'react-device-detect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark';

import loadable from '../../../../utils/loadable';
import { sentimentNavBar, periodTimeValues } from '../../../../data/directory/locations/locationsSentiment';
import { SILVER } from '../../../../data/permissions';
import { STORIES_LIMIT } from '../../../../data/filters/storyFilters';
import StoriesSvc from '../../../../services/StoriesSvc';
import EntitiesSvc from '../../../../services/dbServices/EntitiesSvc';
import { compareFilters } from '../../../../helpers/helpers';
import { pickParams } from '../../../../helpers/commonHelpers';
import { getFlag } from '../../../../helpers/topicsHelpers';
import convertPermalinkToPath from '../../../../helpers/urlHelpers';
import * as storyActions from '../../../../actions/stories.actions';
import * as preferencesActions from '../../../../actions/preferencesActions';
import * as locationsSentiment from '../../../../actions/locationsSentiment.actions';

import permissionsDecorator from '../../../../decorators/permissionsDecorator';

import StoriesUpgradeSuggestion from '../../../SubscriptionsComponents/StoriesUpgradeSuggestion';
import OpenFiltersButton from '../../../StoryFilters/StoryFiltersButton/OpenFiltersButton';
import StoryFilters from '../../../StoryFilters';
import NewStoriesButton from '../../../Buttons/NewStoriesButton';
import NavBar from './NavBar';
import Preloader from '../../../Preloader';
import StoryCard from '../../../TrendingStories/StoryCard';
import RecommendedStories from '../../../RecommendedStories';
import StoryCaughtUp from '../../../StoryCaughtUp';
import SentimentAnalysis from '../../../SentimentAnalysis';
import SentimentByLocation from './SentimentByLocation';
import LocationBySentiment from '../LocationBySentiment';

import Styles from './styles.module.scss';

const Masonry = loadable(() => import('react-masonry-component'));
const cx = classNames.bind(Styles);

class SentimentStories extends Component {
  constructor(props) {
    super(props);
    this.state = {
      storiesNavBar: sentimentNavBar,
      selectedNavValue: 'all',
      activeBoxTab: 'stories',
    };
    autoBind(this);
    this.isTabActive = false;
    this.timer = 0;
    this.storyUpdateTimer = 0;
    this.newStoriesFetching = false;
    this.storiesRef = createRef();
    this.mobileNewStoriesRef = createRef();
    this.storiesListRef = createRef();

    this.cancelToken = axios.CancelToken;
    this.sourceCancelToken = this.cancelToken.source();
  }

  componentDidMount() {
    this.isTabActive = true;
    const { storyFilters } = this.props;
    this.loadStories(storyFilters);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('visibilitychange', this.onVisibilityChange);
  }

  componentDidUpdate(prevProps) {
    const {
      storyFilters, selectedMainTimePeriod, selectedLocation,
    } = this.props;

    if (
      !compareFilters(storyFilters, prevProps.storyFilters)
      || selectedMainTimePeriod !== prevProps.selectedMainTimePeriod
      || !isEqual(selectedLocation, prevProps.selectedLocation)
    ) {
      this.setState({
        pageToken: null,
        newStoriesAvailable: false,
      });
      this.loadStories(storyFilters);
    }
  }

  componentWillUnmount() {
    this.isTabActive = false;
    this.stopTimers();
    clearTimeout(this.loadStoriesTimeout);
    clearTimeout(this.storyUpdateTimer);
    if (this.sourceCancelToken) this.sourceCancelToken.cancel();
    window.removeEventListener('scroll', this.onScroll);
    const { actions } = this.props;
    actions.resetStoriesReduxData();
    actions.freezeStories(false);
    actions.toggleStoryFilters(false);
    window.removeEventListener('visibilitychange', this.onVisibilityChange);
    if (this.sourceCancelToken) this.sourceCancelToken.cancel();
  }

  onPermalinkClick(e) {
    const { history, selectedLocation } = this.props;

    if (selectedLocation.permalink) {
      return;
    }

    e.preventDefault();
    EntitiesSvc.getEntityPermalink({
      entityId: selectedLocation.entity_id,
      entityType: selectedLocation.entity_type,
    }).then(({ permalink }) => {
      if (permalink) {
        selectedLocation.permalink = permalink;
        history.push(convertPermalinkToPath(permalink));
      }
    });
  }

  onTabChange({ id, value }) {
    this.setState(({ storiesNavBar }) => ({
      storiesNavBar: storiesNavBar.map((tab) => ({
        ...tab,
        active: tab.id === id,
      })),
      selectedNavValue: value,
    }), () => {
      this.fetchStories();
    });
  }

  onVisibilityChange() {
    if (document.hidden) {
      clearTimeout(this.loadStoriesTimeout);
      this.loadStoriesTimeout = 0;
      if (this.sourceCancelToken) this.sourceCancelToken.cancel();
      this.isTabActive = false;
    } else {
      if (!this.sourceCancelToken) this.sourceCancelToken = this.cancelToken.source();
      clearTimeout(this.storyUpdateTimer);
      this.storyUpdateTimer = 0;
      this.isTabActive = true;
      const { storyFilters } = this.props;
      this.loadStories(storyFilters);
    }
  }

  onBoxTabChange(tabName) {
    this.setState({
      activeBoxTab: tabName,
    });
  }

  onScroll() {
    const { promobarHeight, isSummary } = this.props;
    const docTop = this.storiesRef.current.offsetTop;
    const docHeight = this.storiesRef.current.offsetHeight;
    const winheight = window.innerHeight === undefined
      ? document.documentElement.clientHeight
      : window.innerHeight;
    const scrollpoint = window.scrollY === undefined
      ? window.document.documentElement.scrollTop
      : window.scrollY;

    const storiesTop = this.storiesRef.current.getBoundingClientRect().top;
    const isFilterFixed = isSummary ? (storiesTop - 20) <= 0 : (storiesTop - 40 - 20) <= 0;

    const newStoriesTop = this.mobileNewStoriesRef.current.getBoundingClientRect().top;
    const isNewStoriesFixed = isSummary
      ? (newStoriesTop - 20) <= 0 : (newStoriesTop - 40 - 20) <= 0;

    this.setState({
      isFilterFixed,
      filterTop: promobarHeight + (isSummary ? 0 : 40),
      isNewStoriesFixed,
    });

    if ((scrollpoint + winheight) >= (docHeight + docTop)) {
      this.onScrollLoadData();
    }
  }

  async onScrollLoadData() {
    const { loading, storyFilters } = this.props;
    const { initialStoriesLoaded, pageToken } = this.state;
    if (this.newStoriesFetching || loading || !initialStoriesLoaded) return;

    if (pageToken !== 'EOD') {
      this.newStoriesFetching = true;
      await this.loadStories(storyFilters, true);
      this.newStoriesFetching = false;
    }
  }

  getParams(filters) {
    const { selectedMainTimePeriod, selectedLocation } = this.props;
    const { selectedNavValue } = this.state;
    const params = pickParams(
      { ...filters },
      'categories', 'order_by', 'languages', 'min_score',
      'all_languages', 'startup_categories',
      'events', 'twitter_following_only', 'with_links',
      'source', 'translate_to', 'premium_only', 'page_token',
      'blacklisted_domain_ids', 'whitelisted_domain_ids', 'domains_filtering_mode',
      'isRefresh',
    );

    if (filters.all_languages) delete params.languages;

    params.all_languages = Boolean(filters.all_languages);
    params.premium_only = filters.premium_content_only;
    params.fold_similar_stories = filters.group_similar_stories;

    params.time_filter = periodTimeValues[selectedMainTimePeriod];

    if (selectedNavValue !== 'all') {
      params.sentiment_levels = selectedNavValue;
    }

    if (selectedLocation) {
      params.query = selectedLocation.query;
    }

    return params;
  }

  async loadStories(filters, nextPage = false) {
    const {
      storyFilters,
      freezeStories,
    } = this.props;
    if (!storyFilters.conflictsChecked) return;
    const { isFilterFixed } = this.state;

    clearTimeout(this.loadStoriesTimeout);
    // Load stories when only when second timeout call when be the same value and not frozen
    if (filters.refresh_rate === storyFilters.refresh_rate && !freezeStories
      && (!filters.isTimeout || (filters.isTimeout && !isFilterFixed))
      && this.isTabActive) {
      const cancelled = await this.fetchStories(nextPage);
      if (cancelled) return;
    }

    if (filters.isScrollTop) {
      clearTimeout(this.storyUpdateTimer);
      this.storyUpdateTimer = 0;
      this.loadStoriesTimeout = setTimeout(this.loadStories, filters.refresh_rate,
        { ...storyFilters, isTimeout: true });
      return;
    }

    if (filters.refresh_rate !== 'never' && Number(filters.refresh_rate) && this.isTabActive) {
      if (nextPage || isFilterFixed) {
        if (!this.storyUpdateTimer) {
          this.storyUpdateTimer = setTimeout(this.checkForUpdate, filters.refresh_rate);
        }
      } else {
        clearTimeout(this.storyUpdateTimer);
        this.storyUpdateTimer = 0;
        this.loadStoriesTimeout = setTimeout(this.loadStories, filters.refresh_rate,
          { ...storyFilters, isTimeout: true });
      }
    }
  }

  async checkForUpdate() {
    const { storyFilters, stories, earliestSearchDate } = this.props;

    const params = this.getParams(storyFilters);
    const { stories: newStories, cancelled } = await StoriesSvc
      .getStories(params, earliestSearchDate, {
        token: this.sourceCancelToken.token, skipSmallList: true,
      });

    if (cancelled) return;

    const nonDuplicateStoriesIds = new Set([
      ...stories.slice(0, STORIES_LIMIT).map(({ id }) => id),
      ...newStories.map(({ id }) => id),
    ]);

    if (nonDuplicateStoriesIds.size > STORIES_LIMIT) {
      this.setState({
        newStoriesAvailable: true,
      });
    } else {
      const { isFilterFixed } = this.state;
      if (isFilterFixed) {
        this.storyUpdateTimer = setTimeout(this.checkForUpdate, storyFilters.refresh_rate);
      } else {
        clearTimeout(this.storyUpdateTimer);
        this.storyUpdateTimer = 0;
        this.loadStoriesTimeout = setTimeout(this.loadStories, storyFilters.refresh_rate,
          { ...storyFilters, isTimeout: true });
      }
    }
  }

  async fetchStories(nextPage = false) {
    const {
      stories: currentStories,
      actions,
      earliestSearchDate,
      freezeStories,
      storyFilters,
      hasSilverAccess,
    } = this.props;
    const {
      initialStoriesLoaded, pageToken, selectedNavValue,
    } = this.state;

    if (!storyFilters.conflictsChecked || (!hasSilverAccess && selectedNavValue !== 'all')) return;

    this.stopTimers();
    const params = {
      ...this.getParams(storyFilters),
      ...(nextPage && {
        page_token: pageToken,
      }),
    };

    if (!freezeStories) {
      actions.fetchTrendingStoriesBegin();

      if (!nextPage) {
        clearTimeout(this.loadStoriesTimeout);
        clearTimeout(this.storyUpdateTimer);
      }

      if (this.sourceCancelToken) this.sourceCancelToken.cancel();

      this.cancelToken = axios.CancelToken;
      this.sourceCancelToken = this.cancelToken.source();

      const { stories, nextPageToken, cancelled } = await StoriesSvc
        .getStories(params, earliestSearchDate, {
          token: this.sourceCancelToken.token, skipSmallList: true,
        });

      if (cancelled) return cancelled;

      actions.fetchTrendingStoriesSuccess(
        nextPage ? [
          ...currentStories,
          ...stories,
        ] : (
          stories
        ),
      );
      this.setState({
        pageToken: nextPageToken,
      });

      if (!initialStoriesLoaded) this.setState({ initialStoriesLoaded: true });
    }
  }

  stopTimers() {
    clearTimeout(this.timer);
  }

  sendUpgradeAction() {
    const { piwikEnabled } = this.props;

    if (piwikEnabled) _paq.push(['trackEvent', 'Premium', 'Upgrade', window.location.href]);
  }

  scrollToStart(fetchNewStories = true) {
    const { storyFilters } = this.props;

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    this.setState({
      newStoriesAvailable: false,
    });
    if (fetchNewStories) {
      this.loadStories({ ...storyFilters, isScrollTop: true });
    }
  }

  handleFilterRefreshClick() {
    const { storyFilters } = this.props;
    this.setState({
      pageToken: null,
      newStoriesAvailable: false,
    });
    this.loadStories({
      ...storyFilters,
      isRefresh: true,
    });
  }

  handleChartModalClose() {
    const { actions } = this.props;
    actions.setSelectedLocation(null);
  }

  returnStories() {
    const { stories, hasSilverAccess } = this.props;
    const { selectedNavValue } = this.state;
    if (!hasSilverAccess && selectedNavValue !== 'all') {
      return [];
    }
    return stories;
  }

  render() {
    const {
      storiesNavBar, initialStoriesLoaded, selectedNavValue,
      activeBoxTab,
      isFilterFixed, filterTop,
      newStoriesAvailable, isNewStoriesFixed,
      pageToken,
    } = this.state;
    const {
      user, windowWidth, loading,
      isLocationsTab, topic, slugType, storyFilters, actions, hasSilverAccess,
      selectedLocation, selectedMainTimePeriod, isLocationPage,
      hideAsideChart,
    } = this.props;

    const storiesArr = this.returnStories();
    const isCompactView = isMobileOnly ? (
      storyFilters.user_newsfeed_compactview
    ) : (
      storyFilters.user_newsfeed_compactview_web
    );
    const userNewsfeedView = isMobileOnly ? (
      storyFilters.user_newsfeed_view
    ) : (
      storyFilters.user_newsfeed_view_web
    );
    const isTilesView = userNewsfeedView === 'tiles' && !isCompactView;
    const pageTitle = `Top Stories ${selectedLocation ? `for ${selectedLocation.entity_name}` : ''}`;
    const pageLink = selectedLocation?.permalink ? convertPermalinkToPath(selectedLocation?.permalink) : '#';
    const flagIcon = selectedLocation
      ? getFlag({ ...selectedLocation, name: selectedLocation.entity_name }) : null;

    const allowMasonry = isTilesView && windowWidth > 767;
    const StoriesWrapper = allowMasonry ? Masonry : 'div';
    const storiesWrapperProps = {
      className: cx({
        tiles_wrapper: isTilesView,
        without_tiles: !isTilesView,
        without_compact: !isCompactView,
      }),
      ...(allowMasonry && {
        disableImagesLoaded: true,
        options: {
          gutter: 10,
          percentPosition: true,
          resize: false,
          isResizeBound: false,
          transitionDuration: 0,
        },
        ref: (c) => { this.masonry = this.masonry || c.masonry; },
      }),
    };

    return (
      <div className={Styles.sentiment_stories}>
        {
          windowWidth <= 767 && !!selectedLocation && (
            <div className={Styles.map_modal_header}>
              <div className={Styles.map_modal_close} onClick={this.handleChartModalClose}>
                <FontAwesomeIcon icon={faXmark} />
              </div>
              {flagIcon && (
                <img
                  className={Styles.flag}
                  src={flagIcon}
                  alt="Flag"
                />
              )}
              <Link
                to={pageLink}
                className={Styles.header_title}
                onClick={this.onPermalinkClick}
              >
                {selectedLocation.entity_name}
              </Link>
              <div className={cx('header_sentiment', selectedLocation.type)}>
                {selectedLocation.storyText || ''}
              </div>
            </div>
          )
        }
        <div className={Styles.sentiment_stories_title}>
          {pageTitle}
          {flagIcon && (
            <img
              className={Styles.flag}
              src={flagIcon}
              alt="Flag"
            />
          )}
        </div>
        <div className={Styles.sentiment_tabs}>
          <div
            className={cx('sentiment_tab', { active: activeBoxTab === 'stories' })}
            onClick={() => this.onBoxTabChange('stories')}
          >
            Stories
          </div>
          <div
            className={cx('sentiment_tab', { active: activeBoxTab === 'sentiment' })}
            onClick={() => this.onBoxTabChange('sentiment')}
          >
            Sentiment
          </div>
        </div>
        <div className={Styles.sentiment_stories_box}>
          <div
            className={cx('sentiment_stories_section', {
              tiles: isTilesView,
              active: activeBoxTab === 'stories',
              'full-width': hideAsideChart,
            })}
            ref={this.storiesRef}
          >
            <div className={Styles.sentiment_stories_title}>
              {pageTitle}
              {flagIcon && (
                <img
                  className={Styles.flag}
                  src={flagIcon}
                  alt="Flag"
                />
              )}
            </div>
            <NavBar tabs={storiesNavBar} onChange={this.onTabChange} tablet={false} />
            <div className={Styles.filters_container}>
              <OpenFiltersButton
                isSwitchButtonHidden
                className={Styles.custom_filter}
                refreshEvent={this.handleFilterRefreshClick}
              />
              <NewStoriesButton
                className={cx('new-stories-btn', { visible: newStoriesAvailable, fixed: isFilterFixed && windowWidth > 767 })}
                onClick={this.scrollToStart}
                style={{ top: `${isFilterFixed && windowWidth > 767 ? filterTop + 15 : 0}px` }}
              />
            </div>
            <div className={Styles.filter_bar}>
              <StoryFilters isSimpleLayout isSentimentLocation />
            </div>
            <div
              ref={this.mobileNewStoriesRef}
              className={cx('new-stories-btn_mobile', { show: newStoriesAvailable })}
            >
              <NewStoriesButton
                className={cx('new-stories-btn', { visible: newStoriesAvailable, fixed: isNewStoriesFixed })}
                onClick={this.scrollToStart}
              />
            </div>
            {
              !hasSilverAccess && selectedNavValue !== 'all' ? (
                <div className={Styles.sentiment_upgrade}>
                  <a
                    className={Styles.pricing_link}
                    href="/pricing"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={this.sendUpgradeAction}
                  >
                    Upgrade
                  </a>
                  &nbsp;to see stories by sentiment category.
                </div>
              ) : (
                <StoriesUpgradeSuggestion classname={Styles.custom_stories_suggestion} />
              )
            }
            <div
              className={cx('sentiment_stories_cards', {
                loading: loading && !this.newStoriesFetching,
                tiles: isTilesView,
              })}
            >
              {(!initialStoriesLoaded) ? (
                <Preloader
                  loading
                  static
                  centered
                />
              ) : (
                <StoriesWrapper {...storiesWrapperProps}>
                  {storiesArr.map((story, index) => (
                    <StoryCard
                      key={story.id}
                      user={user}
                      type={story.type}
                      story={story}
                      onHide={actions.hideStory}
                      onFreezeStories={actions.freezeStories}
                      onLikeChanged={actions.updateStoriesInfo}
                      onBookmarkClick={actions.updateStoriesBookmark}
                      loading={loading}
                      masonryObj={this.masonry}
                      index={index}
                    />
                  ))}
                </StoriesWrapper>
              )}
              {loading && this.newStoriesFetching && (
                <Preloader
                  loading
                  static
                  centered
                />
              )}

              {storiesArr.length < 20 && pageToken === 'EOD' && initialStoriesLoaded && (hasSilverAccess || (!hasSilverAccess && selectedNavValue === 'all')) && (
                <RecommendedStories
                  locations
                  isLocationsSentiments
                  query={selectedLocation && selectedLocation.query}
                  loadingStories={loading}
                  storiesLength={storiesArr.length}
                  oldStories={storiesArr}
                />
              )}

              {storiesArr.length >= 30 && pageToken === 'EOD' && (
                <StoryCaughtUp hideButton />
              )}
            </div>
          </div>
          <div className={cx('sentimet_chart', {
            active: activeBoxTab === 'sentiment',
            hide: hideAsideChart,
          })}
          >
            {
              (activeBoxTab === 'sentiment' || windowWidth > 1023) && (
                <SentimentAnalysis
                  allowWithoutQuery={!isLocationsTab}
                  isFullLocations={!isLocationsTab}
                  selectedLocation={selectedLocation}
                  isTopic={isLocationsTab}
                  topic={topic}
                  slugType={slugType}
                  isTabView={windowWidth <= 1023}
                  isLocationPage={isLocationPage}
                />
              )
            }
            {
              activeBoxTab === 'sentiment' && windowWidth <= 767 && selectedLocation && !isLocationsTab && (
                <SentimentByLocation
                  selectedMainTimePeriod={selectedMainTimePeriod}
                  selectedLocation={selectedLocation}
                  pageLink={pageLink}
                />
              )
            }
            {
              activeBoxTab === 'sentiment' && windowWidth <= 1023 && isLocationsTab && (
                <LocationBySentiment
                  slugType={slugType}
                  topic={topic}
                />
              )
            }
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({
  storyFilters, stories, locationsSentiment, subscriptions,
  common, chatbot,
}) => {
  const { permissions } = subscriptions;
  const hasSilverAccess = permissions.access_levels.includes(SILVER);
  return {
    storyFilters,
    stories: stories.cards,
    loading: stories.loading,
    freezeStories: stories.freeze_stories,
    selectedMainTimePeriod: locationsSentiment.selectedMainTimePeriod,
    selectedLocation: locationsSentiment.selectedLocation,
    hasSilverAccess,
    windowWidth: common.width,
    earliestSearchDate: permissions.earliest_search_date,
    hideAsideChart: chatbot.isChatbotOpened && (common.width > 1024 && common.width < 1500),
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({
    ...storyActions,
    ...preferencesActions,
    ...locationsSentiment,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  permissionsDecorator(withRouter(SentimentStories)),
);
